import React, { Component } from "react";
import { Button, Container, Row } from "react-bootstrap";
import logo from "../img/inductmelive-high-resolution-logo-black-on-transparent-background.png";
import { redirect } from "react-router-dom";

function Home({ session }) {
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center text-center">
      <img src={logo} className="home-logo " />
      {session ? (
        <p>
          <a href="./admin/new">Start a new project</a>
        </p>
      ) : (
        <></>
      )}
    </Container>
  );
}

export default Home;
